import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import type { RootAdmin } from '@/types/api'

interface AuthState {
  accessToken: string | null
  admin: RootAdmin | null
  isHydrated: boolean
  setSession: (token: string, admin: RootAdmin) => void
  setAccessToken: (token: string) => void
  clear: () => void
  setHydrated: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      admin: null,
      isHydrated: false,
      setSession: (token, admin) => set({ accessToken: token, admin, isHydrated: true }),
      setAccessToken: (token) => set({ accessToken: token }),
      clear: () => set({ accessToken: null, admin: null }),
      setHydrated: () => set({ isHydrated: true }),
    }),
    {
      name: 'vsign-root-admin-auth',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.setHydrated()
        }
      },
    }
  )
)
